import {configStore} from 'app/store/global';

export const urlByLang = (lang: string): string => lang === configStore.DEFAULT_LOCALE ? '' : lang;
